import { render, staticRenderFns } from "./checklist-wrap-item.vue?vue&type=template&id=65e28f28&scoped=true"
import script from "./checklist-wrap-item.vue?vue&type=script&lang=js"
export * from "./checklist-wrap-item.vue?vue&type=script&lang=js"
import style0 from "./checklist-wrap-item.vue?vue&type=style&index=0&id=65e28f28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e28f28",
  null
  
)

export default component.exports